import { render, staticRenderFns } from "./FollowersList.vue?vue&type=template&id=1ec4e7e3&"
import script from "./FollowersList.vue?vue&type=script&lang=js&"
export * from "./FollowersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports